var _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJerry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 200",
    width: 600,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 135,
    fontFamily: "Poppins, Montserrat, sans-serif",
    fontWeight: 700,
    fontSize: 160,
    letterSpacing: -6,
    textAnchor: "middle",
    fill: "#0F4C5C"
  }, "Jerry.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJerry);
export default __webpack_public_path__ + "static/media/Jerry.f2f61bd1d89116ea17caae84e9334c07.svg";
export { ForwardRef as ReactComponent };